<template>
  <div class="wrapper">
    <side-bar>
      <mobile-menu>
        <!-- <li class="nav-item">
          <a class="nav-link">
            <i class="ti-panel"></i>
            <p>Stats</p>
          </a>
        </li>
        <drop-down class="nav-item"
                   title="5 Notifications"
                   title-classes="nav-link"
                   icon="ti-bell">
          <a class="dropdown-item">Notification 1</a>
          <a class="dropdown-item">Notification 2</a>
          <a class="dropdown-item">Notification 3</a>
          <a class="dropdown-item">Notification 4</a>
          <a class="dropdown-item">Another notification</a>
        </drop-down>
        <li class="nav-item">
          <a class="nav-link">
            <i class="ti-settings"></i>
            <p>Settings</p>
          </a>
        </li> -->
        <li class="nav-item">
            <router-link :to="{path: '/'}" class="nav-link">
              <i class="icomoon-home"></i>
              <p>
                Home
              </p>
            </router-link>
        </li>
        <li class="nav-item">
            <router-link :to="{path: '/profile'}" class="nav-link">
              <i class="icomoon-user"></i>
              <p>
                My Account
              </p>
            </router-link>
        </li>
        <li class="nav-item">
            <a v-if="$root.canUserDo(['logout'])" href="#!" class="nav-link" @click="$root.logout();">
              <i class="icomoon-exit"></i>
              <p>Log out</p>
            </a>
            <span v-else style="cursor: not-allowed;" class="nav-item text-muted">
              <i class="icomoon-exit"></i>
              <p>Log out</p>  
            </span>
          </li>
        <li class="divider"></li>
      </mobile-menu>
    </side-bar>
    <div :class="{'main-panel': true, 'with-backgound': (['home', 'profile'].indexOf($route.name) > -1)}" style="display: flex; flex-direction: column;">
      <div style="flex: 1 0 auto;">
        <top-navbar></top-navbar>
        <dashboard-content @click.native="toggleSidebar">
        </dashboard-content>
      </div>
      <content-footer></content-footer>
    </div>
  </div>
</template>
<style lang="scss" scoped>
.main-panel.with-backgound {
  background-image: url('/main-panel-bg.png');
  background-repeat: no-repeat;
  background-size: cover;
}
</style>
<script>
import TopNavbar from "./TopNavbar.vue";
import ContentFooter from "./ContentFooter.vue";
import DashboardContent from "./Content.vue";
import MobileMenu from "./MobileMenu";
export default {
  components: {
    TopNavbar,
    ContentFooter,
    DashboardContent,
    MobileMenu
  },
  methods: {
    toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false);
      }
    }
  }
};
</script>
